import { Modal } from "@circle-react-uikit/ModalV2";
import classNames from "classnames";
import { isFunction } from "lodash";
import type { ReactNode } from "react";

import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

export interface ActionModalProps {
  actionText?: string;
  actionVariant?: "primary" | "danger" | "circle";
  children: ReactNode;
  contentPortalId?: string;
  disabled?: boolean;
  formId?: string;
  isOpen?: boolean;
  modalBodyClassName?: string;
  modalContentClassName?: string;
  onAction?: () => void;
  onClose?: () => void;
  size?: "sm" | "md";
  title: string;
  titleClassName?: string;
}

export const ActionModal = ({
  actionText,
  actionVariant = "primary",
  children,
  contentPortalId = "",
  disabled = false,
  formId,
  isOpen = false,
  onAction,
  onClose,
  size = "md",
  title,
  modalContentClassName = "",
  titleClassName = "",
  modalBodyClassName = "",
}: ActionModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={() => {
      if (isFunction(onClose)) void onClose();
    }}
    contentPortalId={contentPortalId}
  >
    <Modal.Overlay />
    <Modal.Content size={size} className={modalContentClassName}>
      <Modal.Header>
        <Modal.Title
          size={size}
          className={classNames(["text-center", titleClassName])}
        >
          {title}
        </Modal.Title>
        <Modal.HeaderActions className="absolute right-0 top-0 mr-6 mt-6">
          {isFunction(onClose) && (
            <Modal.CloseButton
              onClick={() => {
                if (isFunction(onClose)) void onClose();
              }}
            />
          )}
        </Modal.HeaderActions>
      </Modal.Header>
      <Modal.Body className={modalBodyClassName}>{children}</Modal.Body>
      {actionText && (
        <Modal.Footer>
          <Button
            type={formId ? "submit" : "button"}
            form={formId}
            full
            large
            variant={actionVariant}
            disabled={disabled}
            onClick={() => {
              if (isFunction(onAction)) void onAction();
            }}
          >
            {actionText}
          </Button>
        </Modal.Footer>
      )}
    </Modal.Content>
  </Modal>
);
